export default __webpack_public_path__ + "static/media/how-arrow-desktop.00b8b70f.svg";